import { SxProps, useTheme } from "@mui/material"
import { ImdfFeature } from "providers/venue/types"
import { VerticalCard } from "components/card/VerticalCard"
import { deepmerge } from "@mui/utils"

interface IVerticalEventCardProps {
  sx?: SxProps
  data: ImdfFeature
  dense?: boolean
  className?: string
}

export const VerticalEventCard = ({
  sx,
  data,
  dense = false,
  className,
}: IVerticalEventCardProps) => {
  const theme = useTheme()

  const { styleOverrides } = theme.components?.[`VerticalEventCard`] || {}
  const { root } = styleOverrides

  return (
    <VerticalCard
      data={data}
      dense={dense}
      sx={deepmerge(root, sx)}
      className={className}
    />
  )
}
